import * as React from 'react';

function SvgFilter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 24 24" width="1em" {...props}>
      <path
        clipRule="evenodd"
        d="M8.699 5c-.94 0-1.739.634-1.997 1.504H4.564c-.329 0-.564.258-.564.587 0 .329.258.587.587.587h2.138c.235.87 1.058 1.504 1.997 1.504a2.1 2.1 0 002.021-1.504h8.67A.581.581 0 0020 7.091a.581.581 0 00-.587-.587h-8.67A2.15 2.15 0 008.699 5zm.023 1.175c.494 0 .917.4.917.916a.917.917 0 01-1.833 0c0-.517.423-.916.916-.916zm7.049 3.524c-.94 0-1.739.634-1.997 1.504H4.587A.567.567 0 004 11.79c0 .329.258.587.587.587h9.187c.235.87 1.057 1.504 1.997 1.504a2.1 2.1 0 002.02-1.504h1.622A.581.581 0 0020 11.79a.581.581 0 00-.587-.587H17.79a2.1 2.1 0 00-2.02-1.504zm.023 1.175c.494 0 .917.4.917.916a.917.917 0 01-1.833 0c0-.517.4-.916.916-.916zm-6.273 5.498a2.094 2.094 0 014.017 0h5.875c.329 0 .587.258.587.587a.581.581 0 01-.587.587h-5.85a2.101 2.101 0 01-2.021 1.504c-.94 0-1.762-.634-1.997-1.504H4.587A.581.581 0 014 16.959c0-.329.235-.587.587-.587h4.934zm2.937.587a.917.917 0 00-.916-.916c-.493 0-.893.399-.916.916a.917.917 0 001.832 0z"
        fill="#00182E"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgFilter;
